/**
 * Connections to information pulled from the Data API and stored on the website
 */


/**
 * Get our stored API info from WordPress
 * Return a multi-dimensional array of all the things requested
 */
const getStoredData = async (args = []) => {
    return jQuery.ajax({
        type: "post",
        url: acaAjaxUrl,
        data: {
          action: "aca_ajax_get_stored_data",
          args: args
        }
    });
}


export { getStoredData };



